import React from 'react';

import {CopyButton} from 'src/components/copy-button/copy-button';

import {Group, Item} from '@pb/kit-component-group';

type Props = {
    reviews: string[],
    caption: string,
};

const DEFAULT_REVIEWS_MESSAGE = 'No issues identified.';

export const FieldReviewList = ({reviews, caption}: Props) => {
    const text = reviews.length > 0 ? reviews.join(' ') : DEFAULT_REVIEWS_MESSAGE;

    return (
        <Group direction="v" gap="xs">
            <Group>
                <Item><strong>{caption}</strong></Item>
                <CopyButton textToCopy={text}/>
            </Group>
            {reviews.length > 0 ? (
                <Group direction="v" gap="xs">
                    {reviews.map((review, index) => (
                        <Item key={index}>{review}</Item>
                    ))}
                </Group>
            ) : DEFAULT_REVIEWS_MESSAGE}
        </Group>
    );
};
